import type { Move } from '../../../schemas/move';

/**
 * ***Maestro Multiclasse*** — mossa comune oltre il 10° livello (manuale V1
 * rr. 1811-1815). Richiede *Esperto Multiclasse*.
 *
 * Effetto: scegli una mossa **qualsiasi** di un'altra classe. Non prendere
 * mosse multiclasse.
 *
 * Strutturazione (D10 / FI-11):
 *  - Nessun `levelAdjustment` (PG Instancabile L10 → pool include starting +
 *    advanced_2_5 + advanced_6_10, ovvero "qualsiasi").
 */
export const maestroMulticlasse: Move = {
  id: 'common.maestro-multiclasse',
  name: 'Maestro Multiclasse',
  type: 'common',
  trigger: 'Quando prendi questa mossa al level-up (oltre il 10° livello)',
  description: "Scegli una mossa qualsiasi da un'altra classe. Non prendere mosse multiclasse.",
  tags: ['multiclasse'],
  prerequisites: ['common.esperto-multiclasse'],
  replaces: [],
  multiclass: {
    picks: { kind: 'any-other-class' },
  },
};
